<mat-toolbar color="primary" style="height: 49px">
	<div fxFlex fxFlex.lt-md="none" fxLayoutAlign="start start" fxLayoutGap="1rem">
		<a href="https://www.cargochief.com/">
			<img alt="C4" class="logoImage" src="./assets/images/C4_Logo_5.png" />
		</a>

		<div *ngIf="isNotAdmin && showLogout && !smallDeviceScreen" fxLayout="row" fxLayoutGap="1rem">
			<span
				*ngIf="MENU_OPTIONS?.DASHBOARD"
				class="toolbar-menu textWithIcon"
				routerLink="/dashboard"
			>
				<mat-icon
					[class.toolbar-menu-active]="activeMenu.home"
					[class.color-white]="!activeMenu.home"
					class="color-white home-icon"
				>
					home
				</mat-icon>
			</span>

			<!-- 1. Capacity (always first) -->
			<span
				*ngIf="MENU_OPTIONS?.CAPACITY"
				class="toolbar-menu textWithIcon"
				id="capacity"
				routerLink="/capacity"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.capacity"
					[class.color-white]="!activeMenu.capacity"
				>
					Capacity
				</span>
			</span>

			<!-- Projects (when feature flag is OFF - positioned after Capacity) -->
			<span
				(click)="fireViewedProjectsListEvent('projects')"
				*ngIf="showOriginalProjectsMenu && MENU_OPTIONS?.PROJECTS"
				class="toolbar-menu textWithIcon"
				id="projects"
				routerLink="/v2/projects"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.projects"
					[class.color-white]="!activeMenu.projects"
				>
					Projects
				</span>
			</span>

			<!-- 2. Loads -->
			<span
				*ngIf="MENU_OPTIONS?.LOADS"
				class="toolbar-menu textWithIcon"
				id="loads"
				routerLink="/v2/loadsList"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.loads"
					[class.color-white]="!activeMenu.loads"
				>
					Loads
				</span>
			</span>

			<!-- 3. Offers -->
			<span
				*ngIf="MENU_OPTIONS?.OFFERS"
				class="toolbar-menu textWithIcon"
				id="offers"
				routerLink="/v2/offers"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.offers"
					[class.color-white]="!activeMenu.offers"
				>
					Offers
				</span>
			</span>

			<!-- 4. Procurement (plain link — default; also the fallback whenever the Bulk Rating
			     dropdown is not shown, e.g. no split-projects nav or not entitled) -->
			<span
				(click)="fireViewedProjectsListEvent('procurement')"
				*ngIf="showSplitProjectsMenu && MENU_OPTIONS?.PROJECTS && !showProcurementDropdown"
				class="toolbar-menu textWithIcon"
				id="procurement"
				routerLink="/v2/procurement"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.procurement"
					[class.color-white]="!activeMenu.procurement"
				>
					Procurement
				</span>
			</span>

			<!-- 4b. Procurement dropdown (CN-8861 — when Bulk Rating is ON and reachable): Projects + Bulk Rating -->
			<span
				*ngIf="showProcurementDropdown"
				class="toolbar-menu textWithIcon"
				id="procurement"
			>
				<span
					[matMenuTriggerFor]="procurementMenu"
					[class.toolbar-menu-active]="activeMenu.procurement"
					[class.color-white]="!activeMenu.procurement"
					mat-button
				>
					Procurement
				</span>

				<mat-menu #procurementMenu="matMenu">
					<button
						(click)="fireViewedProjectsListEvent('procurement')"
						mat-menu-item
						routerLink="/v2/procurement"
					>
						Projects
					</button>
					<button mat-menu-item routerLink="/users/automation/rfps">Bulk Rating</button>
				</mat-menu>
			</span>

			<!-- 5. Workflows (when feature flag is ON - after Opportunities) -->
			<span
				(click)="fireViewedProjectsListEvent('workflows')"
				*ngIf="showSplitProjectsMenu && MENU_OPTIONS?.PROJECTS"
				class="toolbar-menu textWithIcon"
				id="workflows"
				routerLink="/v2/workflows"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.workflows"
					[class.color-white]="!activeMenu.workflows"
				>
					Workflows
				</span>
			</span>

			<!-- 6. Network -->
			<span
				(click)="sharedService.sendCarrierFullProfileEvent(true)"
				*ngIf="MENU_OPTIONS?.NETWORK"
				class="toolbar-menu textWithIcon"
				id="carriers"
				routerLink="{{ environment.V2_CARRIER_NETWORK_PAGE ? '/v2' : '' }}/carriers"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.network"
					[class.color-white]="!activeMenu.network"
				>
					Network
				</span>
			</span>

			<!-- 7. Reports -->
			<span *ngIf="MENU_OPTIONS?.SCORECARDS || MENU_OPTIONS?.WORKFLOW_PERFORMANCE_REPORT || MENU_OPTIONS?.COVERAGE || MENU_OPTIONS?.STRONG_LANES_DASHBOARD || MENU_OPTIONS?.LANE_CARRIER_ANALYTICS || (MENU_OPTIONS?.BA_PERFORMANCE_METRICS_ENABLED && (utilService.isUserRoleAdmin() || utilService.isUserRoleManager() || utilService.isUserRoleOwner()))" class="toolbar-menu textWithIcon" id="scorecards">
				<span
					[matMenuTriggerFor]="scorecards"
					[class.toolbar-menu-active]="activeMenu.scorecards"
					[class.color-white]="!activeMenu.scorecards"
					mat-button
				>
					Reports
				</span>

				<mat-menu #scorecards="matMenu">
					<button *ngIf="MENU_OPTIONS?.SCORECARDS" mat-menu-item routerLink="/reports/scorecards/lanes">Lanes</button>
					<button
						*ngIf="isAuthorizedForCustomerScorecard()"
						mat-menu-item
						routerLink="/reports/scorecards/customers"
					>
						Customers
					</button>
					<button *ngIf="MENU_OPTIONS?.SCORECARDS" mat-menu-item routerLink="/reports/scorecards/carriers">Carriers</button>
					<button
						mat-menu-item
						routerLink="/reports/scorecards/BAPerformanceMetrics"
						*ngIf="
							MENU_OPTIONS?.BA_PERFORMANCE_METRICS_ENABLED &&
							(utilService.isUserRoleAdmin() ||
								utilService.isUserRoleManager() ||
								utilService.isUserRoleOwner())
						"
					>
						Booking Assistant Performance Metrics
					</button>
					<button
						*ngIf="
							MENU_OPTIONS?.OFFERS &&
							(utilService.isUserRoleAdmin() ||
								environment.FEATURE_FLAGS?.OFFER_ANALYTICS_NON_ADMIN_ENABLED)
						"
						mat-menu-item
						routerLink="/reports/offer-analytics"
					>
						Offer Analytics
					</button>
					<button
						*ngIf="MENU_OPTIONS?.LANE_ANALYTICS"
						mat-menu-item
						routerLink="/reports/lane-analytics"
					>
						Automation Recommendations
					</button>
					<button
						*ngIf="MENU_OPTIONS?.WORKFLOW_PERFORMANCE_REPORT"
						mat-menu-item
						routerLink="/reports/workflow-performance"
					>
						Workflow Performance
					</button>
					<button
						*ngIf="MENU_OPTIONS?.LANE_CARRIER_ANALYTICS"
						mat-menu-item
						routerLink="/reports/lane-carrier-analytics"
					>
						Lane & Carrier Analytics
					</button>
					<!-- CN-9074 — Coverage (plan B6). Listed above Strong Lanes because it
					     absorbs its Top Lanes list: Coverage is now the entry point for
					     "how well is my book covered", and Strong Lanes keeps the
					     destination/backhaul half and the single-lane evaluator. -->
					<button
						*ngIf="MENU_OPTIONS?.COVERAGE"
						mat-menu-item
						routerLink="/reports/coverage"
					>
						Coverage
					</button>
					<button
						*ngIf="MENU_OPTIONS?.STRONG_LANES_DASHBOARD"
						mat-menu-item
						routerLink="/reports/strong-lanes"
					>
						Strong Lanes
					</button>
					<!-- CN-8580/CN-8838 — Recommended Carriers (Reports). Account-gated; shown to
					     ALL users in an enabled account. Managers get the full account report;
					     regular users get a read-only view of just the carriers assigned to them
					     (the role split is handled inside RecommendedCarriersComponent). -->
					<button
						*ngIf="accountSettings.TOP_CARRIERS_ENABLED"
						mat-menu-item
						routerLink="/reports/recommended-carriers"
					>
						Recommended Carriers
					</button>
					<!-- CN-7634 — Usage (Reports). ADMIN or MANAGER role only; account-scoped. -->
					<button
						*ngIf="utilService.isUserRoleAdmin() || utilService.isUserRoleManager()"
						mat-menu-item
						routerLink="/reports/usage"
					>
						Usage
					</button>
				</mat-menu>
			</span>

			<!-- Other menu items (Pricing, Customers) - keeping at the end -->
			<span
				*ngIf="MENU_OPTIONS?.PRICING"
				class="toolbar-menu textWithIcon"
				id="pricing"
				routerLink="/pricing"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.pricing"
					[class.color-white]="!activeMenu.pricing"
				>
					Pricing
				</span>
			</span>

			<span
				(click)="sharedService.closeFullProfileSidenav.next(false)"
				*ngIf="MENU_OPTIONS?.CUSTOMERS"
				class="toolbar-menu textWithIcon"
				id="customers"
				routerLink="/users/customers"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.customers"
					[class.color-white]="!activeMenu.customers"
				>
					Customers
				</span>
			</span>

			<!-- carriers navbar menu -->
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_DASHBOARD"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/dashboard"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierDashboard"
					[class.color-white]="!activeMenu.carrierDashboard"
				>
					Dashboard
				</span>
			</span>
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_AVAILABLE_LOADS"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/availableLoads"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierAvailableLoads"
					[class.color-white]="!activeMenu.carrierAvailableLoads"
					[class.mobile_menu_text]="smallDeviceScreen"
				>
					Available<span *ngIf="smallDeviceScreen"><br /></span> Loads
				</span>
			</span>
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_BOOKED_LOADS"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/bookedLoads"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierBookedLoads"
					[class.color-white]="!activeMenu.carrierBookedLoads"
					[class.mobile_menu_text]="smallDeviceScreen"
				>
					Booked<span *ngIf="smallDeviceScreen"><br /></span> Loads
				</span>
			</span>
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_LANES"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/lanes"
				[class.mobile_toolbar_menu]="smallDeviceScreen"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierLanes"
					[class.color-white]="!activeMenu.carrierLanes"
					[class.mobile_one_line_menu_text]="smallDeviceScreen"
				>
					Lanes
				</span>
			</span>
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_NETWORK"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/network"
				[class.mobile_toolbar_menu]="smallDeviceScreen"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carriersNetwork"
					[class.color-white]="!activeMenu.carriersNetwork"
					[class.mobile_one_line_menu_text]="smallDeviceScreen"
				>
					Network
				</span>
			</span>
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_DISCOVER"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/discover"
				[class.mobile_toolbar_menu]="smallDeviceScreen"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierDiscover"
					[class.color-white]="!activeMenu.carrierDiscover"
					[class.mobile_one_line_menu_text]="smallDeviceScreen"
				>
					Discover
				</span>
			</span>
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_OFFERS"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/offers"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierOffers"
					[class.color-white]="!activeMenu.carrierOffers"
				>
					Offers
				</span>
			</span>
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_QUALITY_SCORE"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/qualityScore"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierQualityScore"
					[class.color-white]="!activeMenu.carrierQualityScore"
				>
					Quality Score
				</span>
			</span>
			<!-- CN-8876 — Bulk Rating for carriers. Carriers have no Procurement nav, so this is
			     Bulk Rating's own top-level item, shown only when the BULK_RATING_ENABLED account
			     setting is on. Carrier-only (showCarrierBulkRating is isAccountTypeCarrier-gated);
			     broker nav is unaffected. Routes to the existing Bulk Rating screen. -->
			<span
				*ngIf="showCarrierBulkRating"
				class="toolbar-menu textWithIcon"
				id="carrierBulkRating"
				routerLink="/users/automation/rfps"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierBulkRating"
					[class.color-white]="!activeMenu.carrierBulkRating"
				>
					Bulk Rating
				</span>
			</span>

			<!-- Carrier profile page for paid carrier accounts-->
			<span
				*ngIf="MENU_OPTIONS?.CARRIER_PROFILE"
				class="toolbar-menu textWithIcon"
				routerLink="/carriers/profile"
			>
				<span
					[class.toolbar-menu-active]="activeMenu.carrierProfile"
					[class.color-white]="!activeMenu.carrierProfile"
				>
					Profile
				</span>
			</span>

			<mat-chip-list *ngIf="isFreeTrial()">
				<mat-chip class="countered-chip mt-8">
					{{
						!utilService.isNullOrUndefined(FREE_TRIAL_DAYS_REMAINING)
							? FREE_TRIAL_DAYS_REMAINING
							: ''
					}}
					days left on your trial
				</mat-chip>
			</mat-chip-list>
		</div>
	</div>

	<!-- Carrier mobile menu options -->
	<div
		*ngIf="smallDeviceScreen && isAccountTypeCarrier && showLogout"
		fxFlex
		fxLayoutAlign="center center"
	>
		<button
			mat-button
			class="page-switcher-trigger"
			[class.open]="carrierSwitcherTrigger.menuOpen"
			[matMenuTriggerFor]="carrierSwitcher"
			#carrierSwitcherTrigger="matMenuTrigger"
			aria-haspopup="menu"
			[attr.aria-expanded]="carrierSwitcherTrigger.menuOpen"
		>
			<span class="page-switcher-label">
				{{
					activeMenu.carrierAvailableLoads
						? 'Available Loads'
						: activeMenu.carrierBookedLoads
							? 'Booked Loads'
							: activeMenu.carrierLanes
								? 'Lanes'
								: activeMenu.carriersNetwork
									? 'Network'
									: activeMenu.carrierDashboard
										? 'Dashboard'
										: activeMenu.carrierOffers
											? 'Offers'
											: activeMenu.carrierQualityScore
												? 'Quality Score'
												: activeMenu.carrierProfile
													? 'Profile'
													: activeMenu.carrierBulkRating
															? 'Bulk Rating'
															: 'Menu'
				}}
			</span>
			<mat-icon class="page-switcher-icon">arrow_drop_down</mat-icon>
		</button>
	</div>
	<!-- END carrier mobile menu -->

	<div
		*ngIf="isNotAdmin && showLogout && isDemoAccount()"
		fxFlex
		fxFlex.lt-md="none"
		class="toolbar-menu-active"
		fxLayoutAlign="center center"
	>
		<span>Demo Account</span>
	</div>

	<div
		*ngIf="
			showLogout &&
			(utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper()) &&
			false
		"
		fxFlex
	>
		<span class="color-white" fxLayoutGap="1rem">
			<mat-slide-toggle
				(change)="layoutSwitched()"
				[(ngModel)]="isFullWidthLayout"
				[labelPosition]="'before'"
				class="font-size-13"
			>
				Try Beta UI
			</mat-slide-toggle>
		</span>
	</div>

	<div
		*ngIf="showSignup"
		class="font-size-13 cursor-pointer"
		fxFlex
		fxFlex.lt-md="none"
		fxLayoutAlign="end end"
	>
		<a [href]="URLS.CONTACT_US"><u class="color-white">Need an account? </u></a>
	</div>

	<div *ngIf="false" fxFlex fxLayoutAlign="center center">
		<span class="color-white" fxLayoutGap="1rem">
			<mat-slide-toggle [checked]="false" [labelPosition]="'before'" class="font-size-13">
				Beta UI
			</mat-slide-toggle>
		</span>
	</div>

	<div *ngIf="showLogout" fxFlex fxFlex.lt-md="none" fxLayoutAlign="end center" fxLayoutGap="1rem">
		<mat-chip-list *ngIf="showCapacitySearchNotification">
			<mat-chip (click)="capacityNotificationClicked()" class="capacity-search-notification mt-8">
				Please give us feedback on this rate.
			</mat-chip>
		</mat-chip-list>

		<div *ngIf="MENU_OPTIONS?.QUICK_SEARCH">
			<app-quick-search
				#quickSearchComponent
				(closeCarrierFullProfile)="closeCarrierFullProfile()"
				(openCarrierFullProfile)="openCarrierFullProfile($event)"
				[laneDetails]="laneDetails"
				fxFlex="100"
			></app-quick-search>
		</div>

		<app-notifications *ngIf="!isAccountTypeCarrier"></app-notifications>

		<!-- Custom Intercom launcher (broker/shipper only) -->
		<button
			*ngIf="
				showLogout &&
				(utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper())
			"
			mat-icon-button
			id="intercomLauncher"
			aria-label="Open support chat"
			(click)="intercomService.openMessenger()"
		>
			<mat-icon
				[matBadge]="intercomService.unreadCount$ | async"
				[matBadgeHidden]="(intercomService.unreadCount$ | async) === 0"
				matBadgeColor="warn"
				matBadgeSize="small"
				class="color-white vertical-align-middle"
			>
				help_outline
			</mat-icon>
		</button>

		<button
			[matMenuTriggerFor]="menu"
			class="pr-0"
			id="logoutMenu"
			mat-button
			[class.mobile_menu_text]="smallDeviceScreen"
		>
			{{ !utilService.isNullOrUndefined(user.firstName) ? user.firstName : '' }}
			<mat-icon>more_vert</mat-icon>
		</button>
	</div>

	<div *ngIf="showSignin" fxFlex fxFlex.lt-md="none" fxLayoutAlign="end end" fxLayoutGap="1rem">
		<span class="color-white font-size-13">Already have an account?</span>
		<span><a mat-raised-button routerLink="/login">Login</a></span>
	</div>
</mat-toolbar>

<mat-menu #menu="matMenu" class="m-t-1 primary-border" xPosition="before">
	<div *ngIf="!utilService.isAccountTypeAdmin()">
		<button
			class="primary-text"
			id="account_settings"
			mat-menu-item
			routerLink="/users/account_settings"
		>
			<span>Account</span>
		</button>

		<app-profile-popover
			#profilePopover
			*ngIf="showLogout"
			[highlightLandingPageSection]="highlightLandingPageSection"
			[showLogout]="showLogout"
		></app-profile-popover>

		<app-notification-popover
			#notificationPopover
			*ngIf="
				showLogout &&
				environment.SHOW_NOTIFICATIONS &&
				(!isAccountTypeCarrier ||
					(isAccountTypeCarrier && environment.FEATURE_FLAGS.CARRIER_NOTIFICATIONS_ENABLED))
			"
		></app-notification-popover>

		<button
			*ngIf="utilService.isUserRoleUser() && productsService.TASKS"
			class="primary-text"
			id="tasks"
			mat-menu-item
			routerLink="/users/tasks"
		>
			<span>Tasks</span>
		</button>

		<button
			*ngIf="!utilService.isAccountTypeCarrier()"
			class="primary-text"
			mat-menu-item
			routerLink="/users/settings/excluded_carriers"
		>
			Excluded Carriers
		</button>

		<button
			*ngIf="environment.AUTOMATION_TOOLS_ENABLED && !utilService.isAccountTypeCarrier()"
			[matMenuTriggerFor]="automationTools"
			class="primary-text"
			mat-menu-item
		>
			<span>Automation Tools</span>
		</button>

		<button
			*ngIf="false"
			class="primary-text"
			id="job_status"
			mat-menu-item
			routerLink="/users/auto_match"
		>
			<span>Job Status</span>
		</button>

		<button
			*ngIf="showMenuItem('team') && isManageUsersEnabled()"
			[matMenuTriggerFor]="team"
			class="primary-text"
			id="team"
			mat-menu-item
		>
			<span>Team</span>
		</button>

		<!--For Carrier Account-->
		<button
			*ngIf="showMenuItem('carrierManageUsers')"
			class="primary-text"
			id="carrier-manage-users"
			mat-menu-item
			routerLink="/carriers/manageUsers"
		>
			<span>Manage Users</span>
		</button>

		<button
			*ngIf="showMenuItem('emailTemplates')"
			class="primary-text"
			mat-menu-item
			routerLink="/users/email_templates"
			[queryParams]="{ templateType: TEMPLATE_TYPE.LOAD_OFFER }"
		>
			Email Templates
		</button>

		<button
			*ngIf="integrationsEnabled()"
			class="primary-text"
			mat-menu-item
			routerLink="/users/integrations"
		>
			<span>Integrations</span>
		</button>

		<a
			*ngIf="!isAccountTypeCarrier"
			class="primary-text"
			href="{{ URLS.HELP_CENTER }}"
			mat-menu-item
			target="_blank"
			rel="noopener noreferrer"
		>
			Help Center
		</a>

		<mat-divider
			*ngIf="USER_ACCOUNT_TYPE !== ACCOUNT_TYPE.ADMIN && utilService.isPaidUser()"
		></mat-divider>
	</div>

	<button (click)="logout()" class="primary-text" id="logout-button" mat-menu-item>
		<span>Logout</span>
	</button>
</mat-menu>

<mat-menu #team="matMenu" xPosition="after" yPosition="below">
	<button
		*ngIf="isManageUsersEnabled()"
		class="primary-text"
		id="manage_users"
		mat-menu-item
		routerLink="/users/manage_users"
	>
		<mat-icon>supervised_user_circle</mat-icon>
		<span>Manage Users</span>
	</button>

	<button
		*ngIf="isEmailRoutingEnabled()"
		class="primary-text"
		id="email_routing"
		mat-menu-item
		routerLink="/users/email_routing"
	>
		<mat-icon>mail</mat-icon>
		<span>Email Routing</span>
	</button>
</mat-menu>

<mat-menu #automationTools="matMenu" xPosition="after" yPosition="below">
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/booking-assistant-automation"
		*ngIf="isAdminOrOwner"
	>
		<span>Booking Assistant</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/rfps"
		*ngIf="showMenuItem('lanesRFP') && !utilService.isAccountTypeCarrier() && !showProcurementDropdown"
	>
		<!-- CN-8875: named "Bulk Rating" for all accounts (flag gates the dropdown/results view, not the name). -->
		<span>Bulk Rating</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/loads"
		*ngIf="showMenuItem('bulkMatch') && !utilService.isAccountTypeCarrier()"
	>
		<span>Loads</span>
	</button>
	<button class="primary-text" mat-menu-item routerLink="/users/automation/transactions">
		<span>Transactions</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/carriers"
		*ngIf="showMenuItem('carrierAutomationPage')"
	>
		<span>Carriers</span>
	</button>
	<button
		class="primary-text"
		mat-menu-item
		routerLink="/users/automation/projects"
		*ngIf="productsService.PROJECT_CARRIERS && !utilService.isAccountTypeCarrier()"
	>
		<span>Projects</span>
	</button>
</mat-menu>

<div *ngIf="isCarrierFullProfileOpened" class="app-default-background h-100vh">
	<app-lane-details
		#laneDetails
		(closeLaneDetails)="closeLaneDetails(laneDetails)"
		[carrierLaneData]="carrierLaneData"
		[recentFeedbackList]="recentFeedbackList"
		[openedMatch]="{
			vettingSource: carrierLaneData?.lane?.vettingSource || null,
			carrierOnboardedOn: carrierLaneData?.lane?.carrierOnboardedOn || null,
			ccBookingRateDisplay: carrierLaneData?.lane?.ccBookingRateDisplay,
			ccEngagementRateDisplay: carrierLaneData?.lane?.ccEngagementRateDisplay,
			ccFalloffRateDisplay: carrierLaneData?.lane?.ccFalloffRateDisplay,
			ccTotalBookedLoads: carrierLaneData?.lane?.ccTotalBookedLoads,
			ccScore: carrierLaneData?.lane?.ccScore,
			lastVettingTime: carrierLaneData?.lane?.lastVettingTime,
			customerCarrier: carrierLaneData?.lane?.customerCarrier,
			carrierActive: carrierLaneData?.lane?.active
		}"
	>
	</app-lane-details>
</div>

<app-default-progress-bar *ngIf="isUploadingFile"></app-default-progress-bar>

<!-- carrier mobile menu -->
<mat-menu
	#carrierSwitcher="matMenu"
	yPosition="below"
	xPosition="after"
	[overlapTrigger]="false"
	panelClass="'carrier-switcher-panel'"
>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_DASHBOARD"
		mat-menu-item
		[routerLink]="'/carriers/dashboard'"
		[disabled]="activeMenu.carrierDashboard"
		[attr.aria-current]="activeMenu.carrierDashboard ? 'page' : null"
	>
		Dashboard
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_AVAILABLE_LOADS"
		mat-menu-item
		[routerLink]="'/carriers/availableLoads'"
		[disabled]="activeMenu.carrierAvailableLoads"
		[attr.aria-current]="activeMenu.carrierAvailableLoads ? 'page' : null"
	>
		Available Loads
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_BOOKED_LOADS"
		mat-menu-item
		[routerLink]="'/carriers/bookedLoads'"
		[disabled]="activeMenu.carrierBookedLoads"
		[attr.aria-current]="activeMenu.carrierBookedLoads ? 'page' : null"
	>
		Booked Loads
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_LANES"
		mat-menu-item
		[routerLink]="'/carriers/lanes'"
		[disabled]="activeMenu.carrierLanes"
		[attr.aria-current]="activeMenu.carrierLanes ? 'page' : null"
	>
		Lanes
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_NETWORK"
		mat-menu-item
		(click)="sharedService.sendCarrierFullProfileEvent(true)"
		[routerLink]="'/carriers/network'"
		[disabled]="activeMenu.carriersNetwork"
		[attr.aria-current]="activeMenu.carriersNetwork ? 'page' : null"
	>
		Network
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_DISCOVER"
		mat-menu-item
		[routerLink]="'/carriers/discover'"
		[disabled]="activeMenu.carrierDiscover"
		[attr.aria-current]="activeMenu.carrierDiscover ? 'page' : null"
	>
		Discover
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_OFFERS"
		mat-menu-item
		[routerLink]="'/carriers/offers'"
		[disabled]="activeMenu.carrierOffers"
		[attr.aria-current]="activeMenu.carrierOffers ? 'page' : null"
	>
		Offers
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_QUALITY_SCORE"
		mat-menu-item
		[routerLink]="'/carriers/qualityScore'"
		[disabled]="activeMenu.carrierQualityScore"
		[attr.aria-current]="activeMenu.carrierQualityScore ? 'page' : null"
	>
		Quality Score
	</button>
	<!-- CN-8876 — Bulk Rating in the carrier mobile switcher (mirrors the desktop item);
	     carrier-only via showCarrierBulkRating, same /users/automation/rfps route. -->
	<button
		*ngIf="showCarrierBulkRating"
		mat-menu-item
		[routerLink]="'/users/automation/rfps'"
		[disabled]="activeMenu.carrierBulkRating"
		[attr.aria-current]="activeMenu.carrierBulkRating ? 'page' : null"
	>
		Bulk Rating
	</button>
	<button
		*ngIf="MENU_OPTIONS?.CARRIER_PROFILE"
		mat-menu-item
		[routerLink]="'/carriers/profile'"
		[disabled]="activeMenu.carrierProfile"
		[attr.aria-current]="activeMenu.carrierProfile ? 'page' : null"
	>
		Profile
	</button>
</mat-menu>
